import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import ExternalRelationsApi from '@infrastructure/external-relations-api';
export const getAllExternalRelationsAsync = createAsyncThunk('externalRelations/getAll', async (payload, { rejectWithValue }) => {
    try {
        const response = await ExternalRelationsApi.getAllExternalRelations(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createExternalRelationAsync = createAsyncThunk('externalRelations/create', async (payload, { rejectWithValue }) => {
    try {
        const response = await ExternalRelationsApi.createExternalRelation(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateExternalRelationAsync = createAsyncThunk('externalRelations/update', async (payload, { rejectWithValue }) => {
    try {
        const response = await ExternalRelationsApi.updateExternalRelation(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteExternalRelationAsync = createAsyncThunk('externalRelations/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await ExternalRelationsApi.deleteExternalRelation(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getExternalRelationByIdAsync = createAsyncThunk('externalRelations/getById', async (id, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await ExternalRelationsApi.getExternalRelationById(id);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllExternalRelationsWithoutPaginationAsync = createAsyncThunk('externalRelations/getAllWithoutPagination', async (eventId, { rejectWithValue }) => {
    try {
        const response = await ExternalRelationsApi.getAllExternalRelationsWithoutPagination(eventId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllExternalRelationRecentEventsAsync = createAsyncThunk('externalRelations/getAllRecentEvents', async (payload, { rejectWithValue }) => {
    try {
        const response = await ExternalRelationsApi.getAllExternalRelationRecentEvents(payload);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
